module.exports = __webpack_public_path__ + "static/vector-aa291db9c675971219f1f425c0a4939e.gif";